import React, { useState } from 'react'
import { map } from 'lodash'

import Zone from '../zone'

import { Container, Content, Image } from './elements'

const ZonesContent = props => {
  const { coverageTree, coverageImage } = props

  const [zoneIdToShow, setZoneIdToShow] = useState(null)

  const onZoneClick = id => setZoneIdToShow(id)

  const renderZone = item => <Zone key={item.id} node={item} zoneIdToShow={zoneIdToShow} onZoneClick={onZoneClick} />

  return (
    <Container>
      {coverageImage && <Image src={coverageImage} />}
      <Content>{map(coverageTree, renderZone)}</Content>
    </Container>
  )
}

export default ZonesContent
